import React, { useMemo } from 'react'

import styles from './StatusInputWrapper.module.scss'
export const StatusSelectInputWrapper = ({
  t,
  selectOptions,
  isValid,
  errorMsg,
  label,
  customClasses,
  isFocussed,
  helperText,
  noteText,
  ...inputProps
}) => {
  const statusClasses = useMemo(() => {
    if (isValid === '') {
      return 'ns-form-group'
    } else if (isValid === true) {
      return 'ns-form-group'
    } else {
      return 'ns-form-group ns-form-group-message-error'
    }
  }, [isValid])

  const inputClasses = useMemo(() => {
    if (isValid === '') {
      return 'ns-input'
    } else if (isValid === true) {
      return 'ns-input'
    } else {
      return 'ns-input ns-input--error'
    }
  }, [isValid])

  return (
    <div className={[statusClasses, styles['fields_margin']].join(' ')}>
      <div className="ns-label-wrapper">
        <label className="ns-label" htmlFor={inputProps.name}>
          {label}
        </label>
      </div>
      {helperText && <div className="ns-hint">{helperText}</div>}
      {!isValid && isValid !== '' && (
        <span id="street-address-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
          <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
          <span className="ns-visually-hidden">{t('shared.error')}</span> {t(errorMsg)}
        </span>
      )}
      <div style={{ display: 'flex', overflow: 'auto' }}>
        <select
          className={inputClasses + ' ' + customClasses}
          style={{
            flexGrow: 1,
            height: '30px',
            minWidth: '3em',
            border: !isValid && isValid !== '' ? '2px solid #a94442' : '1px solid #a2a2a2',
          }}
          {...inputProps}
        >
          <option value={''} key={'none'}>
            {t('mailing_address.select_an_option')}
          </option>
          {Object.keys(selectOptions).map((option) => {
            const value = selectOptions[option]
            return (
              <option value={option} key={option}>
                {value}
              </option>
            )
          })}
        </select>
      </div>

      {noteText && (
        <div className="ns-hint" style={{ fontSize: '0.9rem' }}>
          {noteText}
        </div>
      )}
    </div>
  )
}
